import { css } from 'glamor';

export default css({
  position: 'relative',
  zIndex: 15,
});
